<template>
    <div id="description">
        <div class="material-icons time-icon">notes</div>
        <div class="content">
            <span class="time-label">{{ $t("calendar.description") }}</span>
            <span class="time-sub-label"
                >{{ $t("calendar.descriptionDesc") }}
            </span>
            <textarea v-model="description" class="description-input" />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../../../utils/log2";
import _ from "lodash";
const log = log2("Description");
export default {
    name: "Description",
    components: {},
    props: {
        value: {
            type: String,
        },
    },
    data() {
        return {
            description: _.clone(this.value),
        };
    },
    computed: {
        ...mapState({}),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({}),
        ...mapMutations({}),
        changeVisible() {
            this.visible = !this.visible;
        },
    },
    async mounted() {},
    beforeDestroy() {},
    watch: {
        description(val) {
            this.$emit("input", val);
        },
    },
};
</script>

<style lang="scss" scoped>
#description {
    display: flex;
    flex-direction: row;
    margin-top: 20px;

    .time-icon {
        margin-top: 7px;
        margin-right: 20px;
        font-size: 20px;
    }

    .content {
        display: flex;
        flex-direction: column;

        .time-label {
            color: black;
            font-weight: 500;
            font-size: 16px;
        }

        .time-sub-label {
            font-size: 12px;
        }

        .description-input {
            border: none;
            background-color: #e3e3e3;
            border-radius: 5px;
            height: 70px;
            padding: 10px;
        }
    }
}
</style>
